import { type ReactNode } from "react";
import { AuthSessionProvider } from "./session";
import { AuthTelemetryBridge } from "./AuthTelemetryBridge";
import { AUTH_ENABLED } from "./config";

/* Mounts the in-app auth session only when the deployment opts in
 * (VITE_AUTH_ENABLED="true"). When auth is off we render children directly so
 * no Firebase config is required and nothing auth-related initializes — local
 * dev, tests, Storybook, and algo environments take this path. */
export function AuthProvider({ children }: { children: ReactNode }) {
  if (!AUTH_ENABLED) return <>{children}</>;

  return (
    <AuthSessionProvider>
      <AuthTelemetryBridge />
      {children}
    </AuthSessionProvider>
  );
}
